import React, { useState, useEffect } from 'react';
import { Box, Text, Button, Modal, Chips, Chip, Select as MantineSelect, List } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import { Calendar, ChevronDown } from 'tabler-icons-react';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import classNames from 'classnames';

// Utility Service
import { PriceListing } from '../../helpers';

// API-Services
import { getCourtService, checkBookingService } from '../../service/api.service';

const SchedulerModal = (props) => {
    const navigate = useNavigate();

    const [listOfCourts, setListOfCourts] = useState([]);
    
    const [isCheckedButton, setIsCheckedButton] = useState(true);

    const timingsSS = PriceListing(props?.timings, props?.currency)?.filter(ele => !ele?.includes("undefined"));

    const futureLimit = new Date();
    futureLimit.setDate(futureLimit.getDate() + props?.maxBookingDays);

    // Time validation (currently enabled for both cases; other functionality is kept for future use)
    // const isTimeValid = props?.bookingStartTime || props?.bookingStartTime?.split(' ')?.length === 1 ;

    const isTimeValid = true;
    

    /**
     * @function handleCheckAvailability
     * @params
     * @description used to check availability button
     */


    // const dayPassed = () => {
    //     const time = props?.convert12to24()
    //     const sd = props?.duration;
    //     const [h, m] = time.split(":").map(Number);
    //     return (h*60+m)+(sd*60) <= (24*60)
    // }
 


    const handleCheckAvailability = async () => {
        try {
            if (!props?.bookingDate || !props?.duration || !props?.bookingStartTime) {
                return;
            }
            props?.setCheckedValue([]);
            const result = await getCourtService({
                sports_facility_id: props?.id,
                date: moment(props?.bookingDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                start: props?.convert12to24(),
                no_of_hours: Number(props?.duration),
                uuid: props?.uuid,
            });
            if (result?.data?.success === 1) {
                setListOfCourts(result?.data?.data);
                setIsCheckedButton(false);
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: result?.data?.message || result?.response?.data?.message || 'Something went wrong',
                    icon: 'error', 
                    confirmButtonText: 'Try Again',
                    confirmButtonColor: '#FA5000',
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: error || error?.response?.data?.message || 'Something went wrong',
                icon: 'error',
                confirmButtonText: 'Try Again',
                confirmButtonColor: '#FA5000',
            });
        }
    };

    /**
     * @function proceedWithBooking
     * @params
     * @description used to proceed with booking for make a booking flow
     */
    const proceedWithBooking = async () => {
        try {
            if (!props?.checkedValue || !props?.checkedValue.length) return;
            if (
                props?.facilities?.find((item) => item?.id === props?.id)?.is_deposit_payment &&
                _.some(props?.facilities?.find((item) => item?.id === props?.id)?.timings, (item) =>
                    _.some(item?.prices, (price) => price?.min_deposit > -1)
                )
            ) {
                props?.setOpenedPaymentOptionModal(true);
            } else {
                const result = await checkBookingService({
                    sports_facility_id: props?.id,
                    date: moment(props?.bookingDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    start: props?.convert12to24(),
                    no_of_hours: Number(props?.duration),
                    court_nos: props?.checkedValue,
                    is_deposit: false,
                });
                if (result?.data?.success === 1) {
                    navigate('/booking', {
                        state: {
                            sports_facility_id: props?.id,
                            court_nos: props?.checkedValue,
                            date: moment(props?.bookingDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                            start: props?.convert12to24(),
                            no_of_hours: Number(props?.duration),
                            total_expected_cost: result?.data?.data?.final_amount,
                            sports_name: result?.data?.data?.sports_facility?.name,
                            sports_thumb: result?.data?.data?.sports_facility?.images || [],
                            sports_end_time: props?.calculateEndTime(),
                            sports_start_time: `${props?.bookingStartTime}`,
                            sports_start_bookingAmPm: props?.bookingAmPm,
                            uuid: props?.uuid,
                            facilitiesTitle: props?.facilitiesTitle,
                            courts: props?.courts,
                            timeSlots: props?.timeSlots,
                            id: props?.id,
                            isLockedBookingValue: false,
                            booking: result?.data?.data,
                            complex: result?.data?.data?.sports_facility.sports_complex,
                            complexImage: props?.complexImage,
                        },
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: result?.data?.message || result?.response?.data?.message || 'Something went wrong',
                        icon: 'error',
                        confirmButtonText: 'Try Again',
                        confirmButtonColor: '#FA5000',
                    });
                }
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: error || error?.response?.data?.message || 'Something went wrong',
                icon: 'error',
                confirmButtonText: 'Try Again',
                confirmButtonColor: '#FA5000',
            });
        }
    };

    return (
        <Modal
            opened={props?.opened}
            onClose={() => {
                props?.setOpened(false);
                setListOfCourts([]);
                props?.setCheckedValue([]);
                setIsCheckedButton(true);
                props?.setFcId(null)
                props?.setDuration();
                props?.resetFacilityDate()
            }}
            closeOnClickOutside={false}
            size="lg"
            title="Book Your Slot"
            centered
            sx={() => ({
                '.mantine-Modal-title': {
                    fontSize: 30,
                    fontWeight: 'bold',
                },
                '.mantine-oy9g3x': {
                    backgroundColor: '#252a3d',
                },
                '@media (max-width: 480px)': {
                    '.mantine-Modal-title': {
                        fontSize: 26,
                    },
                },
            })}
        >
            {/* Modal content */}
            <Box>
                <DatePicker
                    placeholder="Pick date"
                    minDate={new Date()}
                    maxDate={futureLimit}
                    value={props?.bookingDate}
                    onChange={(e) => {
                        props?.setBookingDate(e);
                        props?.setCheckedValue([]);
                        setIsCheckedButton(true);
                    }}
                    defaultValue={props?.bookingDate}
                    label="Date"
                    icon={<Calendar size={16} />}
                    sx={() => ({
                        label: {
                            fontSize: 16,
                            fontWeight: 600,
                            color: 'black',
                        },
                    })}
                />

{/* <------ facility Selection start ------->  */} 

                <Box
                    className="mt-3"
                    sx={() => ({
                        display: 'flex',
                        alignItems: 'center',
                        '@media (max-width: 480px)': {
                            flexDirection: 'column',
                            gap: 20,
                        },
                    })}
                >
                    <Box style={{ width: '100%' }}>
                        <Text className="fs-16 fw-600">Select Facility</Text>
                        <MantineSelect
                            sx={() => ({
                                select: {
                                    fontSize: 16,
                                },
                            })}
                            placeholder="Select Facility"
                            rightSection={<ChevronDown size={22} />}
                            rightSectionWidth={30}
                            styles={{
                                rightSection: {
                                    pointerEvents: 'none',
                                },
                            }}
     
                            onChange={(value) => {
                                props?.selectFacility(props?.facility?.subCategory?.find((el)=>String(el.id) === value))
                                setIsCheckedButton(true);
                            }}
                            data={props?.facility?.subCategory?.map((el) =>  (
                                {value: String(el?.id),  label: el?.name,}
                                )) || []}

                               defaultValue={props?.id ? String(props?.id) : null}
                        />
                        {!props?.id && <Text size="xs" color="red">Please select the facility</Text>}
                    </Box>
                </Box>

{/* <------ facility Selection end ------->  */}

                <Box
                    className="mt-3"
                    sx={() => ({
                        display: 'flex',
                        alignItems: 'center',
                        '@media (max-width: 480px)': {
                            flexDirection: 'column',
                            gap: 20,
                        },
                    })}
                >
                    {isTimeValid ? (

                        <Box
                            sx={() => ({
                                display: 'flex',
                                alignItems: 'end',
                                flex: '1 1 50%',
                                maxWidth: '70%',
                                gap: '0 15px',
                                '@media (max-width: 480px)': {
                                    alignItems: 'center',
                                    flex: '1 1 100%',
                                    maxWidth: '100%',
                                    gap: 20,
                                    flexDirection: 'column',
                                },
                            })}
                        >
                            <Box
                                sx={() => ({
                                    flex: '1 1 50%',
                                    maxWidth: '50%',
                                    '@media (max-width: 480px)': {
                                        flex: '1 1 100%',
                                        maxWidth: '100%',
                                    },
                                })}
                            >
                                <Text className="fs-16 fw-600">Start Time</Text>
                                <MantineSelect
                                    value={props?.bookingStartTime?.split(' ')[0] || null}
                                    placeholder="Select Start Time"
                                    rightSection={<ChevronDown size={22} />}
                                    rightSectionWidth={30}
                                    styles={{ rightSection: { pointerEvents: 'none' } }}
                                    onChange={(value) => {
                                        props?.setBookingStartTime(value);
                                        setIsCheckedButton(true);
                                        props?.setCheckedValue([]);
                                    }}
                                    data={
                                         [
                                                  { value: '01:00', label: '1:00' },
                                                  { value: '01:30', label: '1:30' },
                                                  { value: '02:00', label: '2:00' },
                                                  { value: '02:30', label: '2:30' },
                                                  { value: '03:00', label: '3:00' },
                                                  { value: '03:30', label: '3:30' },
                                                  { value: '04:00', label: '4:00' },
                                                  { value: '04:30', label: '4:30' },
                                                  { value: '05:00', label: '5:00' },
                                                  { value: '05:30', label: '5:30' },
                                                  { value: '06:00', label: '6:00' },
                                                  { value: '06:30', label: '6:30' },
                                                  { value: '07:00', label: '7:00' },
                                                  { value: '07:30', label: '7:30' },
                                                  { value: '08:00', label: '8:00' },
                                                  { value: '08:30', label: '8:30' },
                                                  { value: '09:00', label: '9:00' },
                                                  { value: '09:30', label: '9:30' },
                                                  { value: '10:00', label: '10:00' },
                                                  { value: '10:30', label: '10:30' },
                                                  { value: '11:00', label: '11:00' },
                                                  { value: '11:30', label: '11:30' },
                                                  { value: '12:00', label: '12:00' },
                                                  { value: '12:30', label: '12:30' },
                                              ]
                                    }
                                />
                            </Box>
                            <MantineSelect
                                sx={() => ({
                                    flex: '1 1 40%',
                                    maxWidth: '40%',
                                    select: {
                                        fontSize: 16,
                                    },
                                    '@media (max-width: 480px)': {
                                        flex: '1 1 100%',
                                        maxWidth: '100%',
                                    },
                                })}
                                value={props?.bookingAmPm || null}
                                placeholder="Select AM/PM"
                                rightSection={<ChevronDown size={22} />}
                                rightSectionWidth={30}
                                styles={{ rightSection: { pointerEvents: 'none' } }}
                                onChange={(value) => {
                                    props?.setBookingAmPm(value);
                                    setIsCheckedButton(true);
                                    props?.setCheckedValue([]);
                                }}
                                data={[
                                    { value: 'AM', label: 'AM' },
                                    { value: 'PM', label: 'PM' },
                                ]}
                            />
                        </Box>
                    ) : (
                        <Box
                            sx={() => ({
                                display: 'flex',
                                alignItems: 'center',
                                flex: '1 1 50%',
                                maxWidth: '50%',
                                gap: '0 15px',
                                '@media (max-width: 480px)': {
                                    alignItems: 'center',
                                    flex: '1 1 100%',
                                    maxWidth: '100%',
                                    gap: 20,
                                    flexDirection: 'column',
                                },
                            })}
                        >
                            <Box
                                sx={() => ({
                                    flex: '1 1 60%',
                                    maxWidth: '50%',
                                    '@media (max-width: 480px)': {
                                        flex: '1 1 100%',
                                        maxWidth: '100%',
                                    },
                                })}
                            >
                                <Text className="fs-16 fw-600">Start Time</Text>
                                <Text
                                    sx={() => ({
                                        fontSize: 16,
                                    })}
                                >
                                    {props?.bookingStartTime}
                                </Text>
                            </Box>
                        </Box>
                    )}
                    <Box style={{ width: props?.bookingStartTime?.split(' ')?.length === 2 && '60%' }}>
                        <Text className="fs-16 fw-600">Duration</Text>
                        <MantineSelect
                            sx={() => ({
                                select: {
                                    fontSize: 16,
                                },
                            })}
                            placeholder="Select Duration"
                            rightSection={<ChevronDown size={22} />}
                            rightSectionWidth={30}
                            styles={{
                                rightSection: {
                                    pointerEvents: 'none',
                                },
                            }}
                                value={props?.duration}
                            onChange={(value) => {
                                props?.setDuration(value);
                                setIsCheckedButton(true);
                                props?.setCheckedValue([]);
                            }}
                                disabled={!props?.id}
                            data={
                                props?.is30MinAllowed
                                    ? [
                                          { value: '0.5', label: '30 Mins' },
                                          { value: '1', label: '1 Hour' },
                                          { value: '1.5', label: '1.5 Hours' },
                                          { value: '2', label: '2 Hours' },
                                          { value: '2.5', label: '2.5 Hours' },
                                          { value: '3', label: '3 Hours' },
                                          { value: '3.5', label: '3.5 Hours' },
                                          { value: '4', label: '4 Hours' },
                                          { value: '4.5', label: '4.5 Hours' },
                                          { value: '5', label: '5 Hours' },
                                          { value: '5.5', label: '5.5 Hours' },
                                          { value: '6', label: '6 Hours' },
                                      ]
                                    : [
                                          { value: '1', label: '1 Hour' },
                                          { value: '2', label: '2 Hours' },
                                          { value: '3', label: '3 Hours' },
                                          { value: '4', label: '4 Hours' },
                                          { value: '5', label: '5 Hours' },
                                          { value: '6', label: '6 Hours' },
                                      ]
                            }
                        />
                    </Box>
                </Box>
                <p className="mt-3 fs-16 fw-600">Available courts</p>

                <Box
                    className={classNames({
                        border: !isCheckedButton && listOfCourts?.filter((item) => item?.available)?.length > 0,
                        'my-3 p-3':
                            (!isCheckedButton && listOfCourts?.filter((item) => item?.available)?.length > 0) ||
                            isCheckedButton,
                    })}
                    sx={() => ({
                        borderRadius:
                            !isCheckedButton && listOfCourts?.filter((item) => item?.available)?.length > 0 && '15px',
                    })}
                >
                    <Box>
                        {!isCheckedButton &&
                            ((listOfCourts?.filter((item) => item?.available)?.length > 0) ? (
                                <Chips value={props?.checkedValue} onChange={props?.setCheckedValue} multiple>
                                    {listOfCourts
                                        ?.filter((item) => item?.available)
                                        ?.map((courtsItem) => {
                                            return (
                                                <Chip
                                                    key={courtsItem?.court}
                                                    value={courtsItem?.court}
                                                    sx={() => ({
                                                        label: {
                                                            padding: '5px 18px',
                                                            background: '#FFEEE6',
                                                            borderRadius: '5px',
                                                            marginBottom: '5px',
                                                            marginRight: '5px',
                                                            minWidth: '40px',
                                                            cursor: 'pointer',
                                                            height: 40,
                                                            display: 'inline-flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            color: '#FA5000',
                                                            fontSize: 17,
                                                            fontWeight: 500,
                                                            '@media (max-width: 480px)': {
                                                                minWidth: '90px',
                                                            },
                                                        },
                                                        '.mantine-foc7wg:hover': {
                                                            background: 'rgb(180, 43, 45)',
                                                            color: '#ffffff',
                                                        },
                                                        '.mantine-jypj8n.__mantine-ref-filled': {
                                                            background: 'rgb(180, 43, 45)',
                                                            color: '#ffffff',
                                                        },
                                                        '.mantine-jypj8n.__mantine-ref-filled:hover': {
                                                            background: 'rgb(180, 43, 45)',
                                                            color: '#ffffff',
                                                        },
                                                        '.mantine - Chips - iconWrapper': {
                                                            display: 'none',
                                                        },
                                                        span: {
                                                            color: '#ffffff',
                                                        },
                                                    })}
                                                >
                                                    {courtsItem?.court}
                                                </Chip>
                                            );
                                        })}
                                </Chips>
                            ) : (
                                <p className="fw-600 text-center">
                                    No courts are available for the selected time. Please choose a different time or
                                    date.
                                </p>
                            ))}
                        {isCheckedButton && (
                            <Box className="text-center">
                                <Button
                                    sx={() => ({
                                        backgroundColor: '#FA5000',
                                        margin: '0 auto',
                                        '&:hover': {
                                            backgroundColor: '#FA5000',
                                        },
                                    })}
                                    onClick={handleCheckAvailability}
                                    disabled={!props?.bookingDate || !props?.duration || !props?.bookingStartTime}
                                >
                                    Check Available Courts
                                </Button>
                            </Box>
                        )}
                    </Box>
                </Box>
                <p className="fs-16 fw-600 mb-2">Requirements of booking</p>
                <Box className="p-3 border rounded mb-3">
                    {timingsSS?.map((t) => (
                        <p className="fw-600 mb-2" key={t}>
                            {t}
                        </p>
                    ))}
                </Box>
                <List>
                    <List.Item>Please double check your booking details. </List.Item>
                    <List.Item>No refund or cancellation allowed after booking is made.</List.Item>
                </List>
                <Box className="d-flex justify-content-end my-3">
                    <Button
                        sx={() => ({
                            backgroundColor: '#FA5000',
                            '&:hover': {
                                backgroundColor: '#FA5000',
                            },
                        })}
                        onClick={proceedWithBooking}
                        disabled={
                            !props?.checkedValue || !props?.checkedValue.length || props?.checkedValue.length === 0
                        }
                    >
                        Proceed
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default SchedulerModal;
